export const ADD_QUICK_SEARCH_RESULTS = "ADD_QUICK_SEARCH_RESULTS";
export const ADD_GLOBAL_SEARCH_RESULTS = "ADD_GLOBAL_SEARCH_RESULTS";